export default {"src":"/_next/static/media/SocialLinikedin.f2e597ce.svg","height":28,"width":28,"blurWidth":0,"blurHeight":0};